module.exports = __webpack_public_path__ + "static/media/845NorthAvenueNW_2018-07-09_147.67335a37.jpg";